import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import constants from "../constants";
import RouteWithSignup from "../components/RouteWithSignup";
import RouteWithSignIn from "../components/RouteWithSignIn";

// Page imports
import Home from "pages/Home";
import Dentist from "pages/Dentist";
import AboutUs from "pages/AboutUs";
import EventsPage from "../pages/EventsPage";
import Overview from "pages/Overview";
import Faq from "pages/Faq";
import Patient from "pages/Patient";
import Physician from "pages/Physican";
import Pharmacist from "pages/Pharmacist";
import Personnel from "pages/Personnel";
import Supplier from "pages/Supplier";
import HealthcareEnterprise from "pages/Healthcare-Enterprise";
import Products from "pages/Products";
import Features from "pages/Features";
import Pricing from "pages/pricing";
import Contact from "pages/Contact";
import Privacy from "pages/PrivacyPolicy";
import Terms from "pages/TermsCondtion";
import PrivacyPolicyPatient from "pages/PrivacyPolicyPatient";
import TermsCondtionPatient from "pages/TermsCondtionPatient";
import PrivacyPolicyVendor from "pages/PrivacyPolicyVendor";
import TermsCondtionVendor from "pages/TermsCondtionVendor";
import CustomAppointmentConfirmationPage from "components/CustomAppointmentConfirmationPage";
import AppointmentConfirmationPageForNonMiraxis from "components/AppointmentConfirmationPageForNonMiraxis";
import RequestAnAppointment from "patient-scheduling/pages/RequestAppointment";
import Doctors from "../patient-scheduling/pages/Doctors";
import SearchDoctorBySpecialty from "../patient-scheduling/pages/SearchDoctorBySpecialty";
import DoctorDetail from "patient-scheduling/pages/DoctorDetail";
import WaitingListForm from "patient-scheduling/pages/WaitingListForm";
import QuestionnaireForm from "patient-scheduling/pages/QuestionnaireForm";
import SetLocation from "../patient-scheduling/pages/SetLocation";
import DoctorOffices from "../patient-scheduling/pages/Offices";
import DoctorReviewsByOffice from "patient-scheduling/pages/Reviews";
import DownloadIcs from "pages/DownloadIcs";
import PaymentFailed from "pages/PaymentFailed";
import FindDoctors from "pages/FindDoctors";
import MoveToOfficeStaff from "pages/MoveToOfficeStaff";
import NotFound from "components/notFound";
import { isProtectedDeepLink } from "utils/protectedDeepLink";

/**
 * Public routes configuration
 */
const PublicRoutes = ({ signinHandler, signupHandler }) => {
  return (
    <Switch>
      {/*
        MFA is rendered from App; if this Switch runs while the URL is still /authenticate,
        match here so `*` does not redirect to /404.
      */}
      <Route exact path="/authenticate" render={() => null} />
      <Route component={Home} exact path="/" />
      
      <RouteWithSignup
        component={Dentist}
        signupHandler={signupHandler}
        path="/dentist"
      />
      <RouteWithSignup
        component={AboutUs}
        signupHandler={signupHandler}
        path="/about-us"
      />
      <RouteWithSignup
        component={EventsPage}
        signupHandler={signupHandler}
        path="/events"
      />
      <RouteWithSignup
        component={Overview}
        signupHandler={signupHandler}
        path="/overview"
      />
      <Route
        render={(props) => (
          <Faq
            {...props}
            SignupClick={signupHandler}
            LoginClick={signinHandler}
          />
        )}
        path="/faq"
      />
      <RouteWithSignup
        component={Patient}
        signupHandler={signupHandler}
        path="/patient"
      />
      <RouteWithSignup
        component={Physician}
        signupHandler={signupHandler}
        path="/physician"
      />
      <RouteWithSignup
        component={Pharmacist}
        signupHandler={signupHandler}
        path="/pharmacist"
      />
      <RouteWithSignup
        component={Personnel}
        signupHandler={signupHandler}
        path="/personnel"
      />
      <RouteWithSignup
        component={Supplier}
        signupHandler={signupHandler}
        path="/supplier"
      />
      <RouteWithSignup
        component={HealthcareEnterprise}
        signupHandler={signupHandler}
        path="/healthcare-enterprise"
      />
      <RouteWithSignup
        component={Products}
        signupHandler={signupHandler}
        path="/products"
      />
      <RouteWithSignup
        component={Pricing}
        signupHandler={signupHandler}
        path="/pricing"
      />
      <RouteWithSignup
        component={Features}
        signupHandler={signupHandler}
        path="/features"
      />

      <Route component={Contact} path={constants.routes.contact} />
      <Route component={Privacy} path={constants.routes.privacyPolicy} />
      <Route component={Terms} path={constants.routes.termsAndConditions} />
      <Route
        component={CustomAppointmentConfirmationPage}
        path="/appointment-confirmation/:appointment_id"
      />
      <Route
        component={AppointmentConfirmationPageForNonMiraxis}
        path={constants.routes.appointementConfirmationForNonMiraxis}
      />
      <Route
        component={PrivacyPolicyPatient}
        path={constants.routes.privacyPolicyPatient}
      />
      <Route
        component={TermsCondtionPatient}
        path={constants.routes.termsAndConditionsPatient}
      />
      <Route
        component={PrivacyPolicyVendor}
        path={constants.routes.privacyPolicyVendor}
      />
      <Route
        component={TermsCondtionVendor}
        path={constants.routes.termsAndConditionsVendor}
      />

      <RouteWithSignIn
        component={RequestAnAppointment}
        signInHandler={signinHandler}
        path={constants.routes.requestAnAppointment}
      />
      <Route exact component={Doctors} path={constants.routes.doctors} />
      <Route
        exact
        component={SearchDoctorBySpecialty}
        path={constants.routes.searchDoctorBySpecialty}
      />
      <RouteWithSignIn
        component={DoctorDetail}
        signInHandler={signinHandler}
        exact
        path={constants.routes.doctor}
      />
      <RouteWithSignIn
        component={WaitingListForm}
        signInHandler={signinHandler}
        exact
        path={constants.routes.watingListRequest}
      />
      <RouteWithSignIn
        component={QuestionnaireForm}
        signInHandler={signinHandler}
        exact
        path={constants.routes.questionnaireForm}
      />
      <Route
        exact
        component={SetLocation}
        path={constants.routes.setLocation}
      />
      <Route
        exact
        component={DoctorOffices}
        path={constants.routes.doctorOffices}
      />
      <Route
        exact
        component={DoctorReviewsByOffice}
        path={constants.routes.doctorReviews}
      />
      <Route exact component={DownloadIcs} path={constants.routes.downloadIcs} />
      <RouteWithSignIn
        component={PaymentFailed}
        signInHandler={signinHandler}
        exact
        path={constants.routes.paymentfailed}
      />
      <RouteWithSignIn
        component={FindDoctors}
        signInHandler={signinHandler}
        exact
        path={constants.routes.findDoctors}
      />
      <RouteWithSignIn
        component={MoveToOfficeStaff}
        signInHandler={signinHandler}
        exact
        path={constants.routes.officeStaffs}
      />

      <Route component={NotFound} path="/404" />
      {/*
        Authenticated detail links must keep their URL so login can return to them.
        Unknown public URLs still go to /404.
      */}
      <Route
        path="*"
        render={({ location }) =>
          isProtectedDeepLink(location.pathname) ? null : <Redirect to="/404" />
        }
      />
    </Switch>
  );
};

export default PublicRoutes;
